import React, { createContext, FC, useContext } from 'react';
import type { AxiosInstance } from 'axios';
import { useAuth } from '@unbooking/ui-auth';
import { OnboardingRepository } from '@common/repositories';

const getRepositories = (instance: AxiosInstance) => ({
  onboardingRepository: new OnboardingRepository(instance),
});

const RepositoryContext = createContext({} as ReturnType<typeof getRepositories>);

export const useRepository = () => useContext(RepositoryContext);

interface IRepositoryProvider {
  children?: React.ReactNode;
}

export const RepositoryProvider: FC<IRepositoryProvider> = ({ children }) => {
  const { axios } = useAuth();

  return (
    <RepositoryContext.Provider value={getRepositories(axios)}>
      {children}
    </RepositoryContext.Provider>
  )
}